var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCtxc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.897 4.398c-.146-.33.382-.564.528-.25 3.432 5.912 6.864 11.827 10.296 17.748-.183 0-.359-.06-.535-.088l-9.16-1.826c-.3-.015-.366-.5-.073-.572l3.594-.99a.3.3 0 00.198-.418L15.897 4.39v.007z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.37 4.428c.033.048.062.1.087.154 1.086 3.08 2.2 6.16 3.278 9.24.096.256-.264.469-.44.278-.924-.968-1.804-1.965-2.713-2.933-.147-.132-.36-.044-.455.095L5.682 22.358c-.11.117-.205.293-.389.315-.132 0-.22-.103-.293-.205v-.17c3.461-5.954 6.918-11.91 10.37-17.87z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.48 14.995c.176-.051.41.073.352.286-.367 1.276-.755 2.545-1.137 3.813-.058.162.088.308.242.316 4.943.99 9.886 2.016 14.828 3.006.096.015.162.088.235.147v.205l-.14.147H5.88c2.2-2.64 4.393-5.295 6.6-7.92z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtxc);
export default __webpack_public_path__ + "static/media/ctxc.4e3dfce75c752ee22d6f503c1411940c.svg";
export { ForwardRef as ReactComponent };